import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import { Button } from "../GameObjects/Button";

export class MainMenu extends HLF.State {
    private readonly _bg: PIXI.Sprite;
    private readonly _buttons: Button[];

    constructor() {
        super();

        this._bg = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._bg.anchor.set(0.5);
        this._bg.interactive = true;
        this.addChild(this._bg);

        this._buttons = new Array<Button>();
/*
        const button1 = new Button(this.onButton1Pressed.bind(this), "button-default", Constants.SPRITESHEET_UI);
        button1.scale.set(0);
        button1.interactive = false;
        button1.position.set(-150, -150);
        button1.addText("Music Game\nPrototype", Constants.FONT_GEL_MED_35, 35);
        this.addChild(button1);
        this._buttons.push(button1);

        const button2 = new Button(this.onButton2Pressed.bind(this), "button-default", Constants.SPRITESHEET_UI);
        button2.scale.set(0);
        button2.interactive = false;
        button2.position.set(150, -150);
        button2.addText("Music Game\nPrototype\n(Shared Link)", Constants.FONT_GEL_MED_35, 35);
        this.addChild(button2);
        this._buttons.push(button2);
 */
        this.makeChapterButton("1", -300, 150);
        this.makeChapterButton("2", -150, 150);
        this.makeChapterButton("3", 0, 150);
        this.makeChapterButton("4", 150, 150);
        this.makeChapterButton("5", 300, 150);

        this.makeChapterButton("6", -300, 300);
        this.makeChapterButton("7", -150, 300);
        this.makeChapterButton("8", 0, 300);
        this.makeChapterButton("9", 150, 300);
        this.makeChapterButton("10", 300, 300);
    }

    /**
     * Currently acts like a delayed contructor.
     * @param pSize The current window size.
     */
    public init(pSize: PIXI.Point) {
        super.init(pSize);

        PubSub.publishSync(HLF.REGISTER_FOCUSABLES, this._buttons);

        this.onResize(pSize);
    }

    /**
     * Called when a state is destroyed.
     */
    public destroy(pOptions?: {children?: boolean; texture?: boolean; baseTexture?: boolean;}): void {
        super.destroy(pOptions);

        PubSub.publishSync(HLF.CLEAR_FOCUS, undefined);
        PubSub.publishSync(HLF.REGISTER_FOCUSABLES, this._buttons);
    }

    /**
     * Called when the window is resized.
     * @param pSize The new size.
     */
    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
        this._bg.width = pSize.x;
        this._bg.height = pSize.y;
    }

    /**
     * Called after load screen has animated out.
     * If no animation is required, simply remove this function.
     * @param pOnComplete Callback when completed.
     */
    public animateIn(pOnComplete: () => void): void {
        const timeline: TimelineLite = new TimelineLite();
        for (let i = 0; i < this._buttons.length; i++) {
            const element = this._buttons[i];
            timeline.to(element.scale, 0.5, {
                x: 1,
                y: 1,
            }, 0.1 * i);
        }
        timeline.call(this.onAnimateInComplete.bind(this));
        timeline.eventCallback(Constants.TWEEN_ONCOMPLETE, pOnComplete);
    }

    /**
     * Called when transition to leave starts.
     * If no animation is required, simply remove this function.
     * @param pOnComplete Callback when completed.
     */
    public animateOut(pOnComplete: () => void): void {
        const timeline: TimelineLite = new TimelineLite();
        for (let i = 0; i < this._buttons.length; i++) {
            const element = this._buttons[i];
            element.interactive = false;
            timeline.to(element.scale, 0.5, {
                x: 0,
                y: 0,
            }, 0.1 * i);
        }
        timeline.eventCallback(Constants.TWEEN_ONCOMPLETE, pOnComplete);
    }

    /**
     * Called once per frame.
     * @param pDeltaTime Time it took to render the previous frame.
     */
    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    protected onButton1Pressed(): void {
        PubSub.publishSync(HLF.STATE_LOAD_STATE, new HLF.StateToken(
            Constants.STATE_GAME, Constants.LOAD_INTERSTITIAL, ...HLF.StateToken.TRANSITION_SIMPLE_INTERSTITIAL,
        ));
    }

    protected onButton2Pressed(): void {
        PubSub.publishSync(HLF.STATE_LOAD_STATE, new HLF.StateToken(
            Constants.STATE_PLAYBACK, Constants.LOAD_INTERSTITIAL, ...HLF.StateToken.TRANSITION_SIMPLE_INTERSTITIAL,
        ));
    }

    private makeChapterButton(pChapter: string, x:number, y:number) {
        const sceneToLoad = "ch" + pChapter + "_menu";

        const steps = [
			HLF.TransitionStep.AnimCurrentOut,
            HLF.TransitionStep.RemoveCurrent,
            HLF.TransitionStep.ShowLoadScreen,
            HLF.TransitionStep.LoadAssets,
            HLF.TransitionStep.HideLoadScreen,
            HLF.TransitionStep.AttachNewInFront,
            HLF.TransitionStep.UnloadAssets,
            HLF.TransitionStep.AnimNewIn,
        ];

        const onButtonPressed = ()=> {
            PubSub.publishSync( HLF.STATE_LOAD_STATE, new HLF.StateToken(
                { id: sceneToLoad, data: {
                    name: sceneToLoad,
                    back: [Constants.STATE_MENU],
                 }}, Constants.LOAD_INTERSTITIAL, ...steps ));
        }
        const newButton = new Button(onButtonPressed, "button-default", Constants.SPRITESHEET_UI);
        newButton.scale.set(0);
        newButton.interactive = false;
        newButton.position.set(x, y);
        newButton.addText(`Chapter ${pChapter}`, Constants.FONT_GEL_MED_35, 35);
        this.addChild(newButton);
        this._buttons.push(newButton);
        return newButton;
    }

    private onAnimateInComplete(): void {
        for (let i = 0; i < this._buttons.length; i++) {
            const element = this._buttons[i];
            element.interactive = true;
        }
    }
}
